export default {
  namespaced: true,
  state: {
    activeGroup: 0,
    activeCorpus: 0,
    activeFloor: 0,
    activeCategory: 0
  },
  mutations: {
    SET_ACTIVE_GROUP (state, payload) {
      state.activeGroup = payload
    },
    SET_ACTIVE_CORPUS (state, payload) {
      state.activeCorpus = payload
    },
    SET_ACTIVE_FLOOR (state, payload) {
      state.activeFloor = payload
    },
    SET_ACTIVE_CATEGORY (state, payload) {
      state.activeCategory = payload
    }
  },
  actions: {
  },
  modules: {
  }
}
